export function unblank(obj){
    for (const key in obj) {
        if (Object.hasOwnProperty.call(obj, key) && typeof obj[key] == 'string') {
            obj[key] = obj[key].replace(/^\s*|\s*$/g,"");
        }
      }
} 